<template>
  <div class="user_info">
    <el-row :gutter="10">
      
      <el-col :xs="24" :sm="24" :md="24" :lg="24">
        <div class="u_right">
          <div class="r_box">
            <div class="r_box1">
              <div>
                <img v-if="u_img_url" class="dlg_u1" :src="u_img_url" alt="" />
                <img v-else class="r_box3" src="../../assets/img/user.png" alt="" />
              </div>
              <div>
                <div class="r_box4">{{user_data.username}}</div>
                <div class="r_box5">{{user_data.email}}</div>
                <!-- <div class="r_box5" v-if="user_data.company_abbreviation&&userType==1">{{user_data.company_abbreviation}}</div> -->
              </div>
            </div>
            <div class="r_box2">
              <span class="r_box6" @click="set_user = true">{{$t('main.text71')}}</span>
            </div>
          </div>

          <div class="r2_box">
            <div>
              <div class="r_box4 r2_box2">{{$t('main.text2')}}</div>
              <div class="r_box5 r2_box2">{{$t('main.text226')}}</div>
            </div>
            <div>
              <span class="r_box6" @click="set_user_pwd = true">{{$t('main.text71')}}</span>
            </div>
          </div>

          <div class="r2_box">
            <div>
              <div class="r_box4 r2_box2">{{$t('login_google.s_email')}}</div>
            </div>
            <div>
              <span class="r_box6" @click="set_email_dlg = true">{{$t('main.text71')}}</span>
            </div>
          </div>

          <!-- Webhook通知设置 -->
          <div class="r2_box" v-if="userType==1 && isApi">
            <div>
              <div class="r_box4 r2_box2">{{$t('bank_card.Webhook_notif')}}</div>
              <div class="r_box5 r2_box2">{{$t('bank_card.After_the_setting')}}</div>
            </div>
            <div>
              <span class="r_box6" @click="webhook_dlg=true">{{$t('main.text71')}}</span>
            </div>
          </div>

          <!-- "status": 状态 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败 -->
          <div class="kyc_box" v-if="kyc_status==4">
            <!-- ok -->
            <!-- <div class="r3_box r3_box_ok" @click="$router.push('/kyc')"> -->
            <div class="r3_box r3_box_ok" @click="to_kyc">
              <div>
                <div class="r_box4 r2_box2">
                  <img class="success_icon" src="../../assets/img/success_icon.png" alt="">
                  {{$t('main.text3')}}
                </div>
                <div class="r_box5 r2_box2">{{$t('main.text227')}}</div>
              </div>
            </div>
          </div>

          <div class="kyc_box" v-else-if="kyc_status==2||kyc_status==3">
            <!-- 待审核 -->
            <div class="r3_box" @click="to_kyc">
              <div>
                <div class="r_box4 r2_box2">
                  <!-- <img class="success_icon" src="../../assets/img/success_icon.png" alt=""> -->
                  {{$t('main.text3')}}
                </div>
                <div class="r_box5 r2_box2">{{$t('main.text227')}}</div>
              </div>
              <div class="sh_box">
                <el-tooltip placement="bottom">
                  <div slot="content" class="sh_box_text">{{$t('main.text228')}}</div>
                  <span>
                    <img class="sh_box_img" src="../../assets/img/biao.png" alt="">
                    {{$t('main.text229')}}
                  </span>
                </el-tooltip>
              </div>
            </div>
          </div>

          <div class="kyc_box" v-else-if="kyc_status==5">
            <!-- 拒绝 -->
            <div class="r3_box" @click="to_kyc">
              <div>
                <div class="r_box4 r2_box2">
                  <!-- <img class="success_icon" src="../../assets/img/success_icon.png" alt=""> -->
                  {{$t('main.text3')}}
                </div>
                <div class="r_box5 r2_box2">{{$t('main.text227')}}</div>
              </div>
              <div class="sh_box jj_sh_box">
                <el-tooltip placement="bottom">
                  <div slot="content" class="sh_box_text">{{$t('main.text230')}}</div>
                  <span>
                    <img class="sh_box_img" src="../../assets/img/red_err_icon.png" alt="">
                    {{$t('main.text231')}}
                  </span>
                </el-tooltip>
              </div>
            </div>
          </div>

          <div class="kyc_box" v-else>
            <div class="r3_box r3_box_padding">
              <div>
                <div class="r_box4 r2_box2">{{$t('main.text3')}}</div>
                <div class="r_box5 r2_box2">{{$t('main.text227')}}</div>
              </div>
              <div>
                <span class="r_box6" @click="to_kyc">{{$t('main.text232')}}</span>
              </div>
            </div>
            <div class="r4_box">
              <div class="r4_box1">
                <div>
                  <div class="r_box5 r2_box2">{{$t('main.text233')}}</div>
                </div>
                <div>
                  <span class="r_box6" @click="service_btn">{{$t('main.text53')}}</span>
                </div>
              </div>
            </div>
          </div>

          

        </div>
      </el-col>
    </el-row>

    <!-- 修改用户信息 -->
    <el-dialog
      :title="$t('main.text234')"
      :visible.sync="set_user"
      custom-class="dlg element_input"
      append-to-body
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <div class="dlg_u_box">
            <div v-loading="aws_s3_loading" element-loading-background="rgba(0, 0, 0, 0.6)">
              <img v-if="u_img_url" class="dlg_u1" :src="u_img_url" alt="" />
              <img
                v-else
                class="dlg_u1"
                src="../../assets/img/user.png"
                alt=""
              />
            </div>
            <div>
              <div>
                <!-- <el-button class="dlg_u2">Choose file</el-button> -->
                <el-upload
                  ref="my-upload"
                  action="#"
                  :limit="1"
                  :show-file-list="false"
                  accept=".jpg,.jpeg,.png,.JPG,.JPEG"
                  :http-request="ossUpload"
                >
                  <el-button class="dlg_u2">{{$t('main.text89')}}</el-button>
                </el-upload>
              </div>
              <div class="dlg_u3">{{$t('main.text235')}}</div>
            </div>
          </div>
          <el-form class="dlg_form" label-position="top" label-width="80px">
            <el-form-item :label="$t('main.text83')">
              <el-input v-model="u_name"></el-input>
            </el-form-item>
            
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="set_user = false" class="cancel_btn">{{$t('main.text7')}}</el-button>

        <el-button type="primary" class="confirm_btn" @click="u_name_confirm2">{{$t('main.text236')}}</el-button>
        
      </span>
    </el-dialog>

    <!-- 修改密码 -->
    <el-dialog
      :title="$t('main.text2')"
      :visible.sync="set_user_pwd"
      custom-class="dlg element_input"
      append-to-body
      @close="set_pwd_dlg_colse"
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form" label-position="top" label-width="80px">
            <el-form-item :label="$t('main.text237')">
              <el-input v-model.trim="old_pwd" :type="pwdType == true ? 'password' : 'text'"></el-input>
              <span class="show-pwd" @click="pwdType = !pwdType">
                <img :src="pwdType ? pwd_yes : pwd_no" alt="" />
              </span>
            </el-form-item>
            <el-form-item :label="$t('main.text213')">
              <el-input v-model.trim="pwd" :type="pwdType2 == true ? 'password' : 'text'"></el-input>
              <span class="show-pwd" @click="pwdType2 = !pwdType2">
                <img :src="pwdType2 ? pwd_yes : pwd_no" alt="" />
              </span>
            </el-form-item>
            <el-form-item :label="$t('main.text214')">
              <el-input v-model.trim="confirm_pwd" :type="pwdType3 == true ? 'password' : 'text'"></el-input>
              <span class="show-pwd" @click="pwdType3 = !pwdType3">
                <img :src="pwdType3 ? pwd_yes : pwd_no" alt="" />
              </span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="set_user_pwd = false" class="cancel_btn"
          >{{$t('main.text7')}}</el-button
        >
        <el-button type="primary" @click="u_pwd_confirm" class="confirm_btn"
          >{{$t('main.text36')}}</el-button
        >
      </span>
    </el-dialog>

    <!-- Webhook通知设置 -->
    <el-dialog
      :title="$t('bank_card.Webhook_notif')"
      :visible.sync="webhook_dlg"
      custom-class="dlg element_input"
      append-to-body
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form" label-position="top">
            <el-form-item :label="$t('bank_card.KYC_status_change')">
              <el-input v-model.trim="webhook.kyc" :placeholder="$t('bank_card.Please_API_link')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('bank_card.status_noti')">
              <el-input v-model.trim="webhook.topup" :placeholder="$t('bank_card.Please_API_link')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('bank_card.Card_status_noti')">
              <el-input v-model.trim="webhook.cardStatus" :placeholder="$t('bank_card.Please_API_link')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('bank_card.activation_success')">
              <el-input v-model.trim="webhook.activeSuccess" :placeholder="$t('bank_card.Please_API_link')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('bank_card.C_N_Noti')">
              <el-input v-model.trim="webhook.newTransaction" :placeholder="$t('bank_card.Please_API_link')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('bank_card.C_S_Noti')">
              <el-input v-model.trim="webhook.transactionStatusChange" :placeholder="$t('bank_card.Please_API_link')"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="webhook_dlg = false" class="cancel_btn"
          >{{$t('main.text7')}}</el-button
        >
        <el-button type="primary" @click="webhook_dlg_confirm" class="confirm_btn"
          >{{$t('main.text36')}}</el-button
        >
      </span>
    </el-dialog>

    <!-- 修改邮箱 -->
    <el-dialog
      :title="$t('login_google.s_email')"
      :visible.sync="set_email_dlg"
      custom-class="dlg element_input"
      append-to-body
      @close="set_email_dlg_colse"
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form" label-position="top" label-width="80px">
            <el-form-item :label="$t('login_google.e_new_email')">
              <el-input v-model.trim="e_new_email" ></el-input>
              <span v-if="!e_new_email">
                <span class="reg_code_btn_no">{{$t('main.text198')}}</span>
              </span>
              <span v-else>
                <span v-show="show" class="reg_code_btn" @click="send_email_btn">{{$t('main.text198')}}</span>
                <span v-show="!show" class="reg_code_btn_no">{{$t('main.text198')}}({{count}})</span>
              </span>
            </el-form-item>
            <el-form-item :label="$t('login_google.e_authCode')">
              <el-input v-model.trim="e_authCode" ></el-input>
            </el-form-item>
            <el-form-item :label="$t('login_google.e_google_code')">
              <el-input v-model.trim="e_google_code" ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="set_email_dlg = false" class="cancel_btn"
          >{{$t('main.text7')}}</el-button
        >
        <el-button type="primary" @click="u_email_confirm" class="confirm_btn"
          >{{$t('main.text36')}}</el-button
        >
      </span>
    </el-dialog>



  </div>
</template>

<script>
import { getUserInfo, modify, modifyLoginPassword, awsS3Auth,kyc_submit,modifyCompanyAbbreviation,modifyWebhookApi,sendEmail,modifyLoginEmail} from "@/api/api";
import md5 from "js-md5";
import AWS from "aws-sdk";

export default {
  data() {
    return {
      pwd_yes: require("../../assets/img/eye_no_b.png"),
      pwd_no: require("../../assets/img/eye_yes_b.png"),
      pwdType: true,
      pwdType2: true,
      pwdType3: true,
      set_user: false,
      dlg_form: {},
      set_user_pwd: false,
      dlg_form_pwd: {},

      user_data: "",
      u_img_url: "",
      u_name: "",
      // u_email:'',

      old_pwd: "",
      pwd: "",
      confirm_pwd: "",
      aws_s3_loading:false,
      link_acttive:1,
      old_data:'',
      name_data:'',
      kyc_status:'',
      company_abbreviation:"",
      // userType 1 主账号； 2子账号
      userType:sessionStorage.getItem("userType"),
      webhook_dlg:false,
      webhook:{
        kyc:"",
        topup:"",
        cardStatus:"",
        activeSuccess:"",
        newTransaction:"",
        transactionStatusChange:"",
      },
      isApi:false,

      // ----
      set_email_dlg:false,
      e_new_email:"",
      e_authCode:"",
      e_google_code:"",

      show: true,//60秒 倒计时
      count: '',
      timer: null,
      
    };
  },

  destroyed(){
    this.bus.$off('open_view_profile_dlg');
    this.bus.$off('open_change_password_dlg');
  },
  mounted() {
    this.get_user_info();
    this.bus.$on('open_view_profile_dlg',()=>{
      this.set_user=true;
    });
    this.bus.$on('open_change_password_dlg',()=>{
      this.set_user_pwd=true;
    });

  },
  methods: {
    get_user_info() {
      getUserInfo().then((res) => {
        if (res.data.code == 200) {
          this.user_data = res.data.data;
          this.old_data = JSON.parse(JSON.stringify(res.data.data));
          this.u_name = res.data.data.username;
          this.u_img_url = res.data.data.avatar;
          // KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
          this.kyc_status=res.data.data.kyc_status;
          
          this.company_abbreviation = res.data.data.company_abbreviation;
          if(res.data.data.noti_api){
            this.webhook = res.data.data.noti_api;
          }
          this.isApi = res.data.data.isApi;
        }
      });
    },
    async u_name_confirm1() {
      this.set_user = true;
      if (this.u_name == "") {
        this.message.ismessage('error',this.$t('main.text203'));
        return false;
      }
      if (this.company_abbreviation == "") {
        return this.message.ismessage('error',"Corporate Clent Prefix");
      }
      
      if(this.u_name==this.old_data.username){
        this.name_data="";
      }else{
        this.name_data=this.u_name;
      }
      // username	String	用户名
      // avatar	String	头像url
      let set_user_api = false;
      let set_user_api2 = false;
      const res = await modify({
        username: this.name_data,
        avatar: '',
      });
      if (res.data.code == 200) {
        set_user_api = true;
      } else {
        this.message.ismessage('error',res.data.msg);
      }

      const res2 = await modifyCompanyAbbreviation({
        company_abbreviation:this.company_abbreviation
      });
      if (res2.data.code == 200) {
        set_user_api2 = true;
      } else {
        this.message.ismessage('error',res2.data.msg);
      }

      if(set_user_api&&set_user_api2){
        this.message.ismessage('success',this.$t('main.text215'));
        this.set_user = false;
        this.get_user_info();
      }

    },
    async u_name_confirm2() {
      this.set_user = true;
      if (this.u_name == "") {
        return this.message.ismessage('error',this.$t('main.text203'));
      }
      
      if(this.u_name==this.old_data.username){
        this.name_data="";
      }else{
        this.name_data=this.u_name;
      }
      const res = await modify({
        username: this.name_data,
        avatar: '',
      });
      if (res.data.code == 200) {
        this.message.ismessage('success',this.$t('main.text215'));
        this.set_user = false;
        this.get_user_info();
      } else {
        this.message.ismessage('error',res.data.msg);
      }
    },

    set_pwd_dlg_colse() {
      this.old_pwd = "";
      this.pwd = "";
      this.confirm_pwd = "";
    },
    set_email_dlg_colse(){
      this.e_new_email = "";
      this.e_authCode = "";
      this.e_google_code = "";
    },
    u_pwd_confirm() {
      if (this.old_pwd == "") {
        this.message.ismessage('error',this.$t('main.text207'));
        return false;
      }
      if (this.pwd == "") {
        this.message.ismessage('error',this.$t('main.text238'));
        return false;
      }
      if (this.confirm_pwd == "") {
        this.message.ismessage('error',this.$t('main.text208'));
        return false;
      }
      var reg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,12}$/;
      if(!reg.test(this.pwd)){
          this.message.ismessage('error',this.$t('main.text246'));
          return false;
      }
      if (this.pwd != this.confirm_pwd) {
        this.message.ismessage('error',this.$t('main.text209'));
        return false;
      }

      modifyLoginPassword({
        old_password: md5(this.old_pwd),
        password: md5(this.pwd),
        confirm_password: md5(this.confirm_pwd),
      }).then((res) => {
        if (res.data.code == 200) {
          this.message.ismessage('success',this.$t('main.text215'));
          this.set_user_pwd = false;
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("userid");
          sessionStorage.removeItem("fa_dlg");
          this.$router.push("/login");
        } else {
          this.message.ismessage('error',res.data.msg);
        }
      });
    },

    async ossUpload(data) {
      this.aws_s3_loading = true;
      // 上传大小判断
      if (data.file.size / 1000 / 1000 > 5) {
        this.message.ismessage('error',this.$t('main.text239'));
        // 上传之后 清空选中的文件 方便下次上传
        setTimeout(() => {
          this.$refs["my-upload"].clearFiles();
        }, 300);
        this.aws_s3_loading = false;
        return false;
      }
      // 类型 判断
      var testmsg = data.file.name.substring(
        data.file.name.lastIndexOf(".") + 1
      );
      const extension =
        testmsg === "jpg" ||
        testmsg === "jpeg" ||
        testmsg === "JPEG" ||
        testmsg === "JPG" ||
        testmsg === "png" ||
        testmsg === "PNG" ||
        testmsg === "bpm" ||
        testmsg === "BPM";
      if (!extension) {
        this.message.ismessage('error',this.$t('main.text240'));
        // 上传之后 清空选中的文件 方便下次上传
        setTimeout(() => {
          this.$refs["my-upload"].clearFiles();
        }, 300);
        this.aws_s3_loading = false;
        return false;
      }
      await this.S3Auth();
      let file_type = data.file.type.split("/")[1];
      const uploadPath ="license/" +  this.random_16+'.'+file_type;
      let s3 = new AWS.S3();

      let params = {
        Body: data.file,
        Bucket: "data-storage-d3",
        Key: uploadPath,
        ACL: "public-read",
      };

      s3.putObject(params, (err) => {
        if (err) {
          console.log(err);
          console.log(err, err.stack)
          this.aws_s3_loading = false;
          // 上传之后 清空选中的文件 方便下次上传
          setTimeout(() => {
            this.$refs["my-upload"].clearFiles();
          }, 300);
        } else {
          const url ="https://data-storage-d3.s3.ap-southeast-1.amazonaws.com/" +uploadPath;
          if(params&&url){
            // 上传之后 清空选中的文件 方便下次上传
            setTimeout(() => {
              this.$refs["my-upload"].clearFiles();
            }, 300);

            // 图片上传成功
            modify({
              username: '',
              avatar: url,
            }).then((res) => {
              if (res.data.code == 200) {
                this.message.ismessage('success',this.$t('main.text215'));
                this.aws_s3_loading = false;
                this.set_user = false;
                setTimeout(() => {
                  this.get_user_info();
                  this.bus.$emit("user_data",111);
                }, 300);
              } else {
                this.message.ismessage('error',res.data.msg);
                this.aws_s3_loading = false;
              }
            });
          }

          
        }
      });
    },
    // 请求aws的配置参数
    async S3Auth() {
      const res = await awsS3Auth();
      if (res.data.code == 200) {
        this.awsS3_data = res.data.data;
        let current_time = new Date().getTime();
        localStorage.setItem("awss3_token_time", current_time + 3600000 * 10);

        //参数
        AWS.config.update({
          region: "ap-southeast-1",
          credentials: new AWS.CognitoIdentityCredentials({
            IdentityPoolId: this.awsS3_data.IdentityPoolId,
            IdentityId: this.awsS3_data.IdentityId,
            Logins: {
              "cognito-identity.amazonaws.com": this.awsS3_data.Token,
            },
          }),
        });
      }
    },
    service_btn(){
      kyc_submit().then(res=>{
        if(res.data.code==200){
          this.bus.$emit('kf_dlg');
        }else{
          this.message.ismessage('error',res.data.msg);
        }
      })
    },
    async webhook_dlg_confirm(){
      const res = await modifyWebhookApi(this.webhook);
      if(res.data.code!==200){
        return this.message.ismessage('error',res.data.msg);
      }
      this.message.ismessage('success',this.$t('main.text215'));
      this.get_user_info();
      this.webhook_dlg=false;
    },
    to_kyc(){
      if(this.userType==1){
        this.$router.push('/kyc');
      }
    },
    send_email_btn(){
      if (!this.e_new_email) {
        return this.message.ismessage('error',this.$t('main.text204'));
      }
      sendEmail({
        email:this.e_new_email,
        type:'febChangeEmail',
      }).then(res=>{
        if(res.data.code==207){
          this.message.ismessage('success',res.data.msg);
          this.getCode();
          this.email_otp_ok=true;
        }else{
          this.message.ismessage('error',res.data.msg);
          this.email_otp_ok=false;
        }
      })
    },
    getCode(){
     const TIME_COUNT = 60;
     if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
           this.count--;
          } else {
           this.show = true;
           clearInterval(this.timer);
           this.timer = null;
          }
        }, 1000)
      }
    },
    async u_email_confirm(){
      if(
        !this.e_new_email||
        !this.e_authCode||
        !this.e_google_code
        ){
        return false;
      }
      const res2 = await modifyLoginEmail({
        new_email:this.e_new_email,
        authCode:this.e_authCode,
        google_code:this.e_google_code,
      });
      if (res2.data.code != 200) {
        return this.message.ismessage('error',res2.data.msg);
      }
      this.message.ismessage('success',this.$t('main.text215'));
      this.set_email_dlg = false;
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("userid");
      sessionStorage.removeItem("fa_dlg");
      this.$router.push("/login");
    }
    


  },
};
</script>

<style scoped>
.user_info {
  box-sizing: border-box;
  /* padding: 30px; */
}
.u_operation {
  color: #fff;
  font-size: 15px;
  background: rgb(4, 23, 40);
  box-shadow: 0px 4px 8px rgba(3, 13, 22, 0.2);
  border-radius: 16px;
  border: none;
  box-sizing: border-box;
  padding: 12px;
  cursor: pointer;
}
.u_lift li {
  box-sizing: border-box;
  padding: 10px 5px;
}
.u_lift li img {
  width: 20px;
  vertical-align: middle;
  margin-top: -2px;
}
.r_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #04182a;
  border-radius: 16px;
  margin-bottom: 20px;
  box-sizing: border-box;
  padding: 35px;
  /* cursor: pointer; */
}
.r_box1 {
  display: flex;
  align-items: center;
}
.r_box3 {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  /* border: 2px solid #deb981; */
}
.r_box4 {
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #ffffff;
  margin-left: 20px;
  margin-bottom: 4px;
}
.r_box5 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 26px;
  color: #ffffff;
  margin-left: 20px;
  opacity: 0.6;
}
.r_box6 {
  font-size: 15px;
  color: #deb981;
  cursor: pointer;
  margin-right: 20px;
}
.r2_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #04182a;
  border-radius: 16px;
  margin-bottom: 20px;
  box-sizing: border-box;
  padding: 35px;
  /* cursor: pointer; */
}
.r2_box2 {
  margin-left: 0;
}
.ref_code {
  margin-top: 22px;
  /* background: #5A6F87; */
  border-radius: 16px;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  background: url(../../assets/img/box_img_bgc.png) #5a6f87 no-repeat;
  background-size: auto 60%;
  background-position: top right;
}

.ref_code2 {
  width: 60px;
}
.ref_code3 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 26px;
  margin-left: 16px;
  margin-bottom: 5px;
}
.ref_code4 {
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  margin-left: 16px;
}

.dlg_u2,
.dlg_u2:hover {
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border: none;
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: #04182a;
  margin-left: 40px;
  margin-bottom: 8px;
}

/* .dlg_body {
  background: #041e35;
  color: #fff;
}
.d_body {
  box-sizing: border-box;
  padding: 40px 0;
  max-width: 420px;
  margin: auto;
}
.dlg_u_box {
  display: flex;
  align-items: center;
}
.dlg_u1 {
  width: 100px;
  height: 100px;
  border: 2px solid #deb981;
  border-radius: 50%;
}
.dlg_u2,
.dlg_u2:hover {
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border: none;
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: #04182a;
  margin-left: 40px;
  margin-bottom: 8px;
}
.dlg_u3 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  margin-left: 40px;
}
.dlg_form {
  margin-top: 25px;
}
.dlg_form >>> .el-form-item__label {
  line-height: 30px;
  color: #fff;
  padding: 0;
}
.cancel_btn {
  color: #f1c788;
  border-color: #f1c788;
  background: transparent;
}
.confirm_btn {
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  color: #04182a;
  border-color: #f1c788;
  margin-left: 20px;
} */
.link_acttive{
  color: #DEB981;
}

.r3_box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #04182a;
  border-radius: 16px;
  /* margin-bottom: 20px; */
  box-sizing: border-box;
  padding: 35px;
  /* padding-bottom: 10px; */
}
.r3_box_padding{
  padding-bottom: 10px;
}
.r3_box_ok{
  background: #12BA9C;
  padding-bottom: 35px;
  color: #fff;
  cursor: pointer;
}
.success_icon{
  width: 22px;
  margin-right: 10px;
  vertical-align: middle;
  margin-top: -3px;
}

.r4_box{
  background: #04182a;
  border-radius: 16px;
  /* margin-bottom: 20px; */
  box-sizing: border-box;
  padding: 35px;
  padding-top: 0;
}
.r4_box1{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #364655;
  padding-top: 10px;
}
/* 退出弹框 */
.log_out1 img{
  width: 40px;
  display: block;
  margin: auto;
}
.log_out2{
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  margin-top: 16px;
  text-align: center;
  word-break: break-word;
  word-wrap: break-word;
}
.log_out3{
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  opacity: 0.8;
  margin-top: 8px;
  text-align: center;
  word-break: break-word;
  word-wrap: break-word;
}
/* .cancel_btn{
  color: #F1C788;
  border-color: #F1C788;
  background: transparent;
} */
/* .confirm_btn{
  min-width: 86px;
  background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  border-color: #F1C788;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  text-align: center;
  color: #04182A;
  margin-bottom: 15px;
} */
.do_it_later{
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  text-decoration-line: underline;
  color: #DEB981;
  text-align: center;
  cursor: pointer;
  margin-bottom: 15px;
}

/* --over-- */
.sh_box{
  width: 155px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
  border: 1.5px solid #465D78;
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #FFFFFF;
  opacity: 0.6;
}
.sh_box_img{
  width: 23px;
  vertical-align: middle;
  margin-right: 6px;
}
.sh_box_text{
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.el-tooltip__popper.is-dark{
  background: #03101C;
}
.jj_sh_box{
  border-color: #F35F65;
  color: #F35F65;
  width: 120px;
}
.u_right{
  max-width: 92%;
  margin: auto;
}

.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}


</style>

<style scoped>
/* 令牌 */
.reg_code_btn{
  position: absolute;
  right: 5px;
  top: 5px;
  background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 5px 10px;
  font-size: 15px;
  color: #fff;
  line-height: initial;
  cursor: pointer;
}
.reg_code_btn_no{
  position: absolute;
  right: 5px;
  top: 5px;
  background: #000;
  opacity: 0.2;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 5px 10px;
  font-size: 15px;
  color: #fffdfd;
  line-height: initial;
  /* cursor: pointer; */
}

</style>

<style scoped>
@media screen and (max-width: 850px) {
  .r_box,.r2_box,.r3_box,.r4_box{
    padding: 15px;
  }
  .dlg_u1 {
    width: 70px;
    height: 70px;
  }
  .r3_box,.r4_box,.r4_box1{
    display: block;
  }
  .dlg_u_box{
    justify-content: center;
  }
  .dlg_form {
    margin: auto;
    margin-top: 25px;
    width: 80%;
  }
  .el-dialog__footer {
    text-align: center;
  }
  .r_box3{
    width: 65px;
    height: 65px;
  }


}
</style>